const dashboard = {
    greeting: {
      morning: 'おはようございます',
      morningNamed: 'おはようございます、{{name}}さん',
      afternoon: 'こんにちは',
      afternoonNamed: 'こんにちは、{{name}}さん',
      evening: 'こんばんは',
      eveningNamed: 'こんばんは、{{name}}さん',
    },
    title: 'ダッシュボード',
    sheetLabel: '技術ナレッジベース',
    lastUpdated: '最終更新',
    subtitle: 'ナレッジベースの最新状況と、よく使う操作',
    priorityHigh: '重要',
    quickActionsTitle: 'クイックアクション',
    noRecentDocuments: '最近のドキュメントはありません',
    quickActions: {
      upload: '新しい資料をアップロードして解析',
      search: 'ナレッジベース全体を横断検索',
      drbfm: '設計変更から故障モードを分析',
      verification: '設計検証項目を作成・追跡',
    },
    totalDocuments: '総ドキュメント数',
    recentUploads: '最近のアップロード',
    totalViews: '総閲覧数',
    activeUsers: 'アクティブユーザー',
    fromLastMonth: '先月比',
    inLast7Days: '過去7日間',
    allTime: '全期間の登録数',
    latestRecord: '最新の登録日',
    thisMonth: '今月',
    currentlyOnline: '現在オンライン',
    recentDocuments: '最近のドキュメント',
    viewAll: 'すべて表示',
    trendingSearches: 'トレンド検索',
    lastNDays: '過去{{days}}日間',
    announcements: 'お知らせ',
    noAnnouncements: '現在お知らせはありません',
    searches: '{{count}}件の検索',
    announcementAuthor: '開発チーム',
    announcementItems: {
      drbfmKnowledge: {
        title: 'DRBFM関連知識の引用表示を改善',
        message: 'DRBFMの故障モード詳細で、関連ファイルをリンク、抜粋、関連度付きで確認できます。',
      },
      chatQuality: {
        title: 'チャット検索と参照文書の品質を改善',
        message: '検索結果のまとまり、参照文書の関連度表示、根拠付き回答の安定性を改善しました。',
      },
      auditOperations: {
        title: '監査ログと運用観測を強化',
        message: '主要操作の監査ログ、異常検知、管理者向けCSVエクスポートに対応しました。',
      },
      helpRefresh: {
        title: 'ヘルプと操作ガイドを更新',
        message: '検索、チャット、DRBFM、CAD、監査機能の説明を現在の機能に合わせて整理しました。',
      },
    },
  };

export default dashboard;
